import React from 'react';

import {
  SubscriptionStatusName, useRestrictToSubscriptionProviderLazyQuery
} from 'generated/graphql';
import _ from 'lodash';
import {
  authService, routeDirectory
} from 'modules';
import {
  useLocation, useNavigate
} from 'react-router-dom';



const __unprotectedPaths: string[] = [
  '/',
  '/authentication',
  '/superAdmin'
];


const __allowableSubscriptionStates: SubscriptionStatusName[] = [
  'success',
  'incomplete'
];

export interface IProps {}

export const FC: React.FC<IProps> = props => {
  const [fnRunQuery, tuple] = useRestrictToSubscriptionProviderLazyQuery({ fetchPolicy: 'network-only' });
  const location = useLocation();
  const navigate = useNavigate();



  React.useEffect(() => {
    authService
      .getAuthStateObservable()
      .subscribe(authState => {
        if (authState.status === 'loggedIn') {
          fnRunQuery();
        }
      });
  }, [fnRunQuery]);



  React.useEffect(() => {
    if (tuple.called && !tuple.loading && !_.some(__unprotectedPaths, path => _.includes(location.pathname, path))) {
      if (tuple.data?.loggedInUser) {
        if (!_.includes(__allowableSubscriptionStates, tuple.data.loggedInUser.subscriptionStatus)) {
          navigate(routeDirectory.authentication.onboardingPayment.path());
        }

      } else {
        navigate(routeDirectory.authentication.login.path());
      }
    }

  }, [location.pathname, navigate, tuple]);

  return null;
};
